import { render } from "./SectionsDetailTableExample.vue?vue&type=template&id=3fd303c1"
import script from "./SectionsDetailTableExample.vue?vue&type=script&lang=js"
export * from "./SectionsDetailTableExample.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__